<template>
    <div class="questionnaire-container questionnaire-stars row col-sm-7 col-sm-offset-3 col-md-8 col-lg-4 col-md-offset-1 col-lg-offset-4">
        <div class="stars-question-title form-label col-sm-5 col-md-10 col-lg-10">
            <span>{{label}}</span>
        </div>
        <van-radio-group v-model="internalValue" class="stars-options col-sm-5 col-md-10 col-lg-10">
          <van-radio name="1">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale1" style="color: #e96b6e;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #e96b6e;': ''"></span>
            </template>
          </van-radio>
          <van-radio name="2">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale2" style="color: #df282c;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #df282c;': ''"></span>
            </template>
          </van-radio>
          <van-radio name="3">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale3" style="color: #f9b83a;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #f9b83a;': ''"></span>
            </template>
          </van-radio>
          <van-radio name="4">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale4" style="color: #b3db6b;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #b3db6b;': ''"></span>
            </template>
          </van-radio>
          <van-radio name="5">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale5" style="color: #91ce6e;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #91ce6e;': ''"></span>
            </template>
          </van-radio>
          <van-radio name="6">
            <template #icon="props">
              <span class="icon iconfont icona-ratingscale6" style="color: #5bb42b;" :class="props.checked ? 'checked' : ''" :style="props.checked ? 'background: #5bb42b;': ''"></span>
            </template>
          </van-radio>
        </van-radio-group>
        <div v-if="notice" class="col-xs-12 col-sm-offset-5 col-md-offset-5 col-lg-offset-4 col-sm-7 col-md-7 col-lg-12 notice-text">{{ this.notice }}</div>
        <div v-if="errorMessage || internalErrorMessage" class="col-xs-12 col-sm-7 col-md-7 col-lg-12 error-text">{{ this.internalErrorMessage || this.errorMessage }}</div>
    </div>
</template>
<script>
import { questionnaireMixin } from './mixin.js'

export default {

  mixins: [questionnaireMixin],
  props: ['label', 'isEditable', 'notice', 'placeholder', 'value', 'isRequired', 'errorMessage'],
  components: {
  },
  data () {
    return {
      internalErrorMessage: '',
      internalValue: null,
      activeIcon: 'https://img.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://b.yzcdn.cn/vant/icon-demo-1126.png'
    }
  },
  model: {
    event: 'change'
  },
  created () {
    this.internalValue = this.value
  },
  watch: {
    '$i18n.locale' (val) {
      this.validate()
    },
    internalValue (val) {
      this.validate()
      this.$emit('change', val)
    },
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    }
  },
  methods: {
    validate () {
      if (this.fieldIsRequired(this.isRequired)) {
        if (!this.internalValue) {
          this.internalErrorMessage = this.$t('questionnaire.error.isRequired')
          return false
        }
      }
      this.internalErrorMessage = ''
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/questionnaire-common.scss';
.questionnaire-stars {
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;

  .stars-question-title {
    text-align: left;
    margin-bottom: -10px;
    justify-content: flex-start;
  }
  .stars-options {
    display: flex;
    padding: 0px;
    align-items: center;
    justify-content: space-between;

    ::v-deep {
      .van-radio {
        height: 50px;
      }

      .van-radio__icon {
        height: auto;
      }

      .iconfont {
        font-size: 36px;
        border-radius: 50%;
        padding: 1px;
      }

      .checked::before {
        border-radius: 50%;
        color: #FFFFFF;
      }
    }
  }

}
</style>
